import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {IMyOptions} from "mydatepicker";
import {User} from "../type/user";
import {Company} from "../type/company";
import {Category} from "../type/category";
import {CompanyStatus} from "../type/company-status";

@Component({
    selector: 'app-company-add',
    templateUrl: './company-add.component.html',
})
export class CompanyAddComponent implements OnInit {
    node = 'company';
    usersNode = 'user';
    companyStatusNode = 'company-status';
    companyCategoryNode = 'company-category';
    users: User = [User];
    company: Company = Company;
    companyCategories: [Category] = [Category];
    companyStatuses: CompanyStatus = [CompanyStatus];

    myDatePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
    };

    constructor(
        private apiService: ApiService,
        private dataService: DataService,
        private location: Location
    ) {}

    ngOnInit() {
        this.dataService.refresh();
        this.getUsers();
        this.getCompanyStatuses();
        this.getCompanyCategories();
    }

    getUsers() {
        this.apiService.getAll(this.usersNode)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.users = [User];
                } else {
                    this.users = response.json().data;
                }
            })
    }

    getCompanyStatuses() {
        this.apiService.getAll(this.companyStatusNode)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.companyStatuses = [CompanyStatus];
                    } else {
                        this.companyStatuses = response.json().data;
                    }
                },
                (error) => {this.companyCategories = [CompanyStatus];}
            );
    }

    getCompanyCategories() {
        this.apiService.getCatAll(this.companyCategoryNode)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.companyCategories = [Category];
                    } else {
                        this.companyCategories = response.json().data;
                    }
                },
                (error) => {this.companyCategories = [Category];}
            );
    }

    onFormSubmit(formData) {
        var data = {
            company_name: formData.value.company_name,
            contact_person: formData.value.contact_person,
            designation: formData.value.designation,
            landline: formData.value.landline,
            mobile: formData.value.mobile,
            email: formData.value.email,
            website: formData.value.website,
            location: formData.value.location,
            description: formData.value.description,
            additional_info: formData.value.additional_info,
            company_status_id: formData.value.company_status_id,
            company_category: formData.value.company_category,
            company_quota: formData.value.company_quota,
            priority_level: formData.value.priority_level,
            last_contacted_by: formData.value.last_contacted_by,
            last_contacted_at: (formData.value.last_contacted_at.formatted)?formData.value.last_contacted_at.formatted:'',
            created_at: (formData.value.created_at.formatted)?formData.value.created_at.formatted: '',
            approved_status: formData.value.approved_status,
        };
        this.apiService.postNew(this.node, data)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Error: ' + response.json().message);
                    } else {
                        alert('Success: ' + response.json().message);
                        this.location.back();
                    }
                },
                (error) => alert('Error: Unable to submit form')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/companies/company-add.component.ts